import { render, staticRenderFns } from "./SelectAngkatan.vue?vue&type=template&id=61526b84"
import script from "./SelectAngkatan.vue?vue&type=script&lang=js"
export * from "./SelectAngkatan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports